import { lazy } from "react";
import { RouteConfig } from "../../../../types/RouteConfig";

export const editEventRoute: RouteConfig<'with-page'> = {
    name: 'Place an Event',
    path: '/work-opps/place-event/:workOppId',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    permissions: ['workOps'],
}